export async function fetchBlob(url:string):Promise<Blob>{
  const response=await fetch(url,{credentials:'include'});
  if(!response.ok)throw new Error('Не удалось получить файл. Серверная копия не удалена.');
  const blob=await response.blob();
  if(!blob.size)throw new Error('Получен пустой файл. Серверная копия не удалена.');
  return blob;
}
export function downloadBlob(blob:Blob,name:string):void{
  const url=URL.createObjectURL(blob),link=document.createElement('a');
  link.href=url;link.download=name;link.hidden=true;document.body.append(link);
  try{link.click()}finally{link.remove();setTimeout(()=>URL.revokeObjectURL(url),60_000)}
}
